module.exports = __webpack_public_path__ + "img/victrix-cinture-6.48a5d074.jpg";